import { Controller } from '@hotwired/stimulus';

// The compact rail, open or shut: fire/shared/_rail, fire's /hq and every
// host's own (docs/HQ.md § The rail).
//
// One class on the drawer, read by everything inside it through Tailwind's
// `group-[.rail-shut]/rail:` variant, so nothing here has to know what the
// rail is made of. The cookie is not a nicety: the server reads it to draw
// the first frame already shut, and without it the rail flashes open on
// every page load and snaps closed a frame later.
//
// Registered as "hq-rail" and not "sidebar": more than one app has a
// sidebar controller of its own for the front of the house.
export default class extends Controller {
  // The session store's own domain (Rails' session_options[:domain], from
  // hq_rail_domain), or nothing: a host-only session keeps a host-only rail.
  // Never worked out here from the hostname: ".com.br" is not a domain.
  static values = { domain: String };

  // A Turbo-cached page comes back drawn the way it was left; the cookie has
  // moved since. Connect is the one place that sees both.
  connect() {
    this.element.classList.toggle('rail-shut', this.cookie === 'shut');
  }

  toggle() {
    // Below lg the rail is daisyUI's overlay: this button shuts it and
    // hands focus back to the checkbox, whose ring is the menu button's.
    // 64rem is Tailwind's lg, read off the browser default in every host.
    if (!matchMedia('(min-width: 64rem)').matches) {
      // This drawer's own checkbox: #fire-rail in /hq, #org-rail in a host's.
      const box = this.element.querySelector(':scope > .drawer-toggle');
      box.checked = false;
      box.focus();
      return;
    }
    const shut = this.element.classList.toggle('rail-shut');
    const domain = this.domainValue ? `;domain=${this.domainValue}` : '';
    document.cookie = `fire_rail_state=${shut ? 'shut' : 'open'};path=/${domain};max-age=31536000;samesite=lax`;
  }

  get cookie() {
    return document.cookie.match(/(?:^|; )fire_rail_state=([^;]*)/)?.[1];
  }
}
